import script from "./WordDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./WordDashboard.vue?vue&type=script&setup=true&lang=js"

import "./WordDashboard.vue?vue&type=style&index=0&id=7f0e93ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f0e93ae"]])

export default __exports__